import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "mt-6",
  "data-test": "content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "title is-4" }, "Redirect URLs", -1)
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "column is-narrow" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "column py-1" }
const _hoisted_12 = { class: "column py-1 is-narrow" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUrl) = $event)),
              class: "input",
              type: "text",
              placeholder: "URL",
              "data-test": "url-input"
            }, null, 512), [
              [_vModelText, _ctx.newUrl]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loadingUrl }]),
          disabled: !_ctx.newUrl,
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addUrl && _ctx.addUrl(...args))),
          "data-test": "submit-url"
        }, _hoisted_10, 10, _hoisted_8)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationUrls, (url, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "columns",
        key: index,
        "data-test": "url-list"
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(url.url), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: _normalizeClass(["button is-white", { 'is-loading': url.id === _ctx.deletingUrl }]),
            "aria-label": "close",
            type: "button",
            "data-test": "delete-url",
            onClick: ($event: any) => (_ctx.deleteUrl(url.id))
          }, _hoisted_15, 10, _hoisted_13)
        ])
      ]))
    }), 128))
  ]))
}